import * as React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {MainLayout} from "./MainLayout";
import Cookies from "js-cookie";
import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import DataTableTemplate from "../../Cpanel/Components/DataTableTemplate";
import { fetchData } from '../../Cpanel/Components/Utilities';

const Subsets = () => {
    const navigate = useNavigate()
    const {name, family, coin, regdate: userRegDate, InsPay, grade} = useSelector((state) => state.auth);
    let userLevel = ''
    switch (grade) {
        case 0: {
            userLevel = 'عادی'
            break;
        }
        case 1: {
            userLevel = 'نقره ای'
            break;
        }
        case 2: {
            userLevel = "پلاتینیوم"
            break;
        }
        default: {
            userLevel = 'عادی'
        }
    }

    const [defaultDatatableRows, setDefaultDatatableRows] = useState(10);
    const cols = [{
        field: 'ckDate', header: 'ردیف',
        body: (data, options) => options.rowIndex + 1
    }, {
        field: 'Name', header: 'نام'
    },
        {field: 'ّFamily', header: 'نام خانوادگی'},
        {field: 'RegDate', header: "تاریخ"},
        {field: 'ckIn', header: 'سکه دریافتی'},
        {field: 'ckOut', header: 'سکه خرج شده'},
        {field: 'remain', header: 'باقیمانده'},
    ]



    const [userList, setUserList] = useState([])
    const [totalRecords, setTotalRecords] = useState(0);
    const [defaultRows, setDefaultRows]= useState(20)
    const [lazyState, setLazyState] = useState({
        first: 0,
        page: 0,
        rows: defaultRows,

    });
  
    useEffect(() => {
        const bodyFormData = new FormData()
        bodyFormData.append('guid', Cookies.get(
            
        ))
        fetchData("referrallist", bodyFormData, handleApiResponse);
    }, [lazyState]);
const handleApiResponse = (data) => {
    setUserList(data?.dt);
    setTotalRecords(data?.count)
}
    return (<div className=' container'>
      <button
        className=" btn btn-outline-secondary fw-bold d-flex align-items-center gap-2  "
        onClick={()=> navigate(-1)}
      >
        <span>
          {" "}
          <FontAwesomeIcon
            icon={"arrow-right"}
            className="fa-small "
          ></FontAwesomeIcon>{" "}
        </span>
        <span>بازگشت</span>
      </button>
        <div className="card wd-75 wm-100 m-auto container">
            <div className="card-body">
                {/* <h5 className="card-title text-center"><span
                    className='text-warning'><FontAwesomeIcon icon="people"
                                                              className='header-icon fs4'/></span> زیر مجموعه های من
                     </h5>
                <p className='text-center text-warning fs-6'>
                    </p>
                <div className="card"> */}
                <DataTableTemplate lazyState={lazyState}
                    // select='select'
                                   className={'table-border'}
                                   columns={cols} list={userList}
                                   totalRecords={totalRecords}
                                   setlazyState={setLazyState}
                                   setDefaultDatatableRows={setDefaultDatatableRows}
                                   defaultDatatableRows={defaultDatatableRows}
                                   width='25rem'/>
                
            </div>
        </div>
    </div>);
};

export default ()=> <MainLayout children={<Subsets/>} />;